import type { IconComponent } from '@components/icons/types'

/** Quote symbol (quotation mark) */
export const Quote: IconComponent = ({
    width = '25',
    height = '20',
    ...props
}) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        viewBox='0 0 25 20'
        {...props}
    >
        <path
            d='M.34 8.947c0-2.674.922-4.936 2.716-6.53C4.388 1.13 5.567.566 8.027 0l2.255 3.908c-1.999.308-3.024.72-4.049 1.594-.922.771-1.28 1.594-1.435 3.445h5.894v10.335H.34V8.947zm13.735 0c0-2.674.922-4.936 2.664-6.53C18.123 1.13 19.302.566 21.711 0l2.255 3.908c-2 .308-3.024.72-3.998 1.594-.974.771-1.281 1.594-1.435 3.445h5.842v10.335h-10.3V8.947z'
            fillOpacity='.5'
        />
    </svg>
)
